module.exports = __webpack_public_path__ + "img/teac_tn4d_arm.9829f167.png";